import { Button, Dropdown, Form, Input, InputNumber, Menu, Popover, Radio, Select, Slider, Switch } from "antd"
import React, { useRef, useState } from "react"
import TextEditor from "./TextEditor"
import { IblocTableCustom, IblocMap, IblocTableMap, IblocTablePonctuel, IblocText, IModule, RankPossibilities, ItableCustomLine, TableMapMode, PotentielChoice, cellCustomStyle } from "./util"
import { PlusOutlined, EditOutlined, DeleteOutlined, FormatPainterOutlined } from '@ant-design/icons'

interface IpropsAddBloc {
    index: number
    module: IModule
    typeData: 'dataPageGarde' | 'dataSurfacique' | 'dataMethodologie' | 'dataPonctuel'
    addBloc: (type: string, index: number, moduleId: string, moduleDataName: string) => void
    blocsAvailable: ('map' | 'text' | 'tableCustom' | 'tableMap' | 'tablePonctuel')[]
}

interface IpropsText {
    indexModule: number
    index: number
    blocData: IblocText
    module: IModule
    updateModule: (m: IModule) => void
}

interface IpropsMap {
    module: IModule
    blocData: IblocMap
    index: number
    updateModule: (m: IModule) => void
    openCloudinary: (m: IModule, imageSrc: 'logo' | 'carteStandard') => void
}

interface IpropsTableSurfacique {
    indexModule: number
    index: number
    blocData: IblocTableMap
    module: IModule
    updateModule: (m: IModule) => void
}

interface IpropsTablePonctuel {
    indexModule: number
    index: number
    blocData: IblocTablePonctuel
    module: IModule
    updateModule: (m: IModule) => void
}

interface IpropsCustomTable {
    indexModule: number
    index: number
    blocData: IblocTableCustom
    module: IModule
    updateModule: (m: IModule) => void
}

export function AddBlocElem(props: IpropsAddBloc) {
    return (
        <div>
            <br />
            <Dropdown
                trigger={['click']}
                overlay={
                    <Menu>
                        {props.blocsAvailable.map(e => (
                            <Menu.Item key={e + props.index} onClick={() => {
                                props.addBloc(e, props.index + 1, props.module.id, props.typeData)
                            }}>{e}</Menu.Item>
                        ))}
                    </Menu>
                }
            >
                <Button icon={<PlusOutlined />} style={{ marginLeft: '10px' }} type='primary' shape='round'>Ajouter un bloc</Button>
            </Dropdown>
            <br />
        </div>
    )
}


export function BlocText(props: IpropsText) {
    const dataName = "data" + props.module.typeModule?.[0].toUpperCase() + props.module.typeModule?.substring(1)
    return (
        <div>
            <Form.Item label="Bloc texte" style={{ marginTop: 15, maxWidth: 900 }}>
                <TextEditor key={"" + props.indexModule + props.index} type={props.blocData.elemType} value={props.blocData.value} uniqueId={"" + props.indexModule + props.index} callback={(type: 'title1' | 'title2' | 'title3' | 'text', value: string, remove: boolean) => {
                    var temp: IModule = { id: '' }
                    temp = Object.assign(temp, props.module)
                    if (temp[dataName]) {
                        if (remove) {
                            temp[dataName].blocs.splice(props.index, 1)
                        }
                        else {
                            temp[dataName].blocs[props.index] = { elemType: type, value: value }
                        }
                    }
                    props.updateModule(temp)
                }} />
            </Form.Item>
        </div>
    )
}


export function BlocMap(props: IpropsMap) {
    const moduleRef = useRef<IModule>(props.module)
    const listePotentiel = [{ value: 'pot_total', text: 'Total' }].concat(
        Array.from(Array(10).keys()).map((i) => ({ value: `pot${i + 1}`, text: `Potentiel ${i + 1}` })),
    )
    const dataName = "data" + props.module.typeModule?.[0].toUpperCase() + props.module.typeModule?.substring(1)
    const { Option } = Select
    return (
        <div>
            <Form.Item label="Bloc carte">
                <br />
                <p>Nom de la carte</p>
                <Input defaultValue={props.blocData.name || ""} onBlur={(e) => {
                    var temp: IModule = { id: '' }
                    temp = Object.assign(temp, props.module)
                    if (temp[dataName]) {
                        props.blocData.name = e.target.value
                        temp[dataName].blocs[props.index] = props.blocData
                    }
                    props.updateModule(temp)
                }} />
                <br />
                <br />
                <p>Style de la carte</p>
                <Radio.Group
                    value={props.blocData.rank}
                    onChange={(e) => {
                        var temp: IModule = { id: '' }
                        temp = Object.assign(temp, props.module)
                        if (temp[dataName]) {
                            props.blocData.rank = e.target.value as RankPossibilities
                            temp[dataName].blocs[props.index] = props.blocData
                        }
                        props.updateModule(temp)
                    }}
                >
                    <Radio key={'rg4'} value={'rg4'}>
                        Afficher la carte rg4
                    </Radio>
                    <Radio key={'rg5'} value={'rg5'}>
                        Afficher la carte rg5
                    </Radio>
                    {props.module.typeModule == "pageGarde" && (
                        <Radio key={'custom'} value={'custom'}>
                            Afficher une carte standard
                        </Radio>
                    )}
                </Radio.Group>
                {props.blocData.rank == "rg5" && (
                    <div>
                        <br />
                        <br />
                        <p>Choix d'un potentiel</p>
                        <Select
                            defaultValue={props.blocData.potentielChoice || null}
                            placeholder="potentiel"
                            onChange={(x: string) => {
                                var temp: IModule = { id: '' }
                                temp = Object.assign(temp, props.module)
                                if (temp?.[dataName]?.blocs[props.index].elemType == "map") {
                                    temp[dataName].blocs[props.index] = { elemType: "map", rank: props.blocData.rank, potentielChoice: x }
                                }
                                moduleRef.current = temp
                            }}
                            onBlur={() => props.updateModule(moduleRef.current)}
                        >
                            {listePotentiel.map((x) => (
                                <Option key={x.value} value={x.value}>
                                    {x.text}
                                </Option>
                            ))}
                            <Option value={null}>Pas de potentiel</Option>
                        </Select>
                    </div>
                )}
                {props.blocData.rank == 'custom' && (
                    <div>
                        <div style={{ marginTop: 20 }}>
                            <Button
                                className="btn widget-btn"
                                onClick={() => props.openCloudinary(props.module, 'carteStandard')}
                            >
                                Charger carte standard{' '}
                            </Button>
                        </div>
                        <div>
                            <p>L'Aperçu de la carte apparaîtra ci-dessous :</p>
                            {props.module[dataName]?.cloudinaryDataCarteStandard && (
                                <img
                                    src={props.module[dataName].cloudinaryDataCarteStandard.secureUrl}
                                    className="displayed-image"
                                />
                            )}
                        </div>
                    </div>
                )}
                {props.blocData.rank != "custom" && (
                    <div>
                        <br />
                        <p>Isochrone</p>
                        {!props.blocData.isochrone && (
                            <Button onClick={() => {
                                var temp: IModule = { id: '' }
                                temp = Object.assign(temp, props.module)
                                if (temp[dataName]) {
                                    props.blocData.isochrone = { type: 'time', value: 30, mode: 'car' }
                                    temp[dataName].blocs[props.index] = props.blocData
                                }
                                props.updateModule(temp)
                            }}>
                                Ajouter une isochrone
                            </Button>
                        )}
                        {props.blocData.isochrone && (
                            <div>
                                <Button danger onClick={() => {
                                    var temp: IModule = { id: '' }
                                    temp = Object.assign(temp, props.module)
                                    if (temp[dataName]) {
                                        delete props.blocData.isochrone
                                        temp[dataName].blocs[props.index] = props.blocData
                                    }
                                    props.updateModule(temp)
                                }}>
                                    Supprimer l'isochrone
                                </Button>
                                <br />
                                <br />
                                <p>Type</p>
                                <Radio.Group
                                    defaultValue={props.blocData.isochrone.type}
                                    onChange={(e) => {
                                        var temp: IModule = { id: '' }
                                        temp = Object.assign(temp, props.module)
                                        if (temp[dataName] && props.blocData.isochrone) {
                                            props.blocData.isochrone.type = e.target.value
                                            temp[dataName].blocs[props.index] = props.blocData
                                        }
                                        props.updateModule(temp)
                                    }}
                                >
                                    <Radio key={'time'} value={'time'}>
                                        Temps (en min)
                                    </Radio>
                                    <Radio key={'distance'} value={'distance'}>
                                        Distance (en km)
                                    </Radio>
                                </Radio.Group>
                                <br />
                                <br />
                                <p>Mode</p>
                                <Radio.Group
                                    defaultValue={props.blocData.isochrone.mode}
                                    onChange={(e) => {
                                        var temp: IModule = { id: '' }
                                        temp = Object.assign(temp, props.module)
                                        if (temp[dataName] && props.blocData.isochrone) {
                                            props.blocData.isochrone.mode = e.target.value
                                            temp[dataName].blocs[props.index] = props.blocData
                                        }
                                        props.updateModule(temp)
                                    }}
                                >
                                    <Radio key={'car'} value={'car'}>
                                        En voiture
                                    </Radio>
                                    <Radio key={'walk'} value={'walk'}>
                                        En marchant
                                    </Radio>
                                </Radio.Group>
                                <br />
                                <br />
                                <p>Valeur</p>
                                <Input defaultValue={props.blocData.isochrone.value} placeholder="Valeur" type={'number'} onBlur={(e) => {
                                    var temp: IModule = { id: '' }
                                    temp = Object.assign(temp, props.module)
                                    if (temp[dataName] && props.blocData.isochrone) {
                                        props.blocData.isochrone.value = Number.parseInt(e.target.value)
                                        temp[dataName].blocs[props.index] = props.blocData
                                    }
                                    props.updateModule(temp)
                                }} />
                            </div>
                        )}

                    </div>
                )}
                <br />
                <Button
                    danger
                    icon={<DeleteOutlined />}
                    style={{ marginTop: 30 }}
                    onClick={() => {
                        var temp: IModule = { id: '' }
                        temp = Object.assign(temp, props.module)
                        if (temp[dataName]) {
                            temp[dataName].blocs.splice(props.index, 1)
                        }
                        props.updateModule(temp)
                    }}
                >Supprimer le bloc</Button>
            </Form.Item>
        </div>
    )
}

export function BlocTableSurfacique(props: IpropsTableSurfacique) {
    const moduleRef = useRef<IModule>(props.module)
    const { Option } = Select
    const listeProduits = Array.from(Array(11).keys()).map((i) => ({
        value: `pot${i}`,
        text: `Produit ${i}`,
    }))
    const dataName = "data" + props.module.typeModule?.[0].toUpperCase() + props.module.typeModule?.substring(1)
    const listePotentiel = [{ value: 'pot_total', text: 'Total' }].concat(
        Array.from(Array(10).keys()).map((i) => ({ value: `pot${i + 1}`, text: `Potentiel ${i + 1}` })),
    )
    return (
        <div>
            <Form.Item label="Tableau surfacique">
                <br />
                <p>Produits à afficher ?</p>
                <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="produit"
                    onBlur={(e) => {
                        props.updateModule(moduleRef.current)
                    }}
                    onChange={(x: string[]) => {
                        var temp: IModule = { id: '' }
                        temp = Object.assign(temp, props.module)
                        if (temp.dataSurfacique) {
                            props.blocData.tableauColonnesProduits = x
                            temp.dataSurfacique.blocs[props.index] = props.blocData
                        }
                        moduleRef.current = temp
                    }}
                    defaultValue={props.blocData.tableauColonnesProduits}
                >
                    {listeProduits.map((x) => (
                        <Option key={'key_1' + x.value} value={x.value}>
                            {x.text}
                        </Option>
                    ))}
                </Select>
                <br />
                <br />
                <p>Metrics à afficher</p>
                <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="metrics"
                    defaultValue={props.blocData.tableauColonnesMetrics}
                    onChange={(x: string[]) => {
                        var temp: IModule = { id: '' }
                        temp = Object.assign(temp, props.module)
                        if (temp.dataSurfacique) {
                            props.blocData.tableauColonnesMetrics = x
                            temp.dataSurfacique.blocs[props.index] = props.blocData
                        }
                        moduleRef.current = temp
                    }}
                    onBlur={() => props.updateModule(moduleRef.current)}
                >
                    <Option key="potentiel" value="pot_total">
                        potentiel
                    </Option>
                    <Option key="ventes" value="ventes">
                        ventes
                    </Option>
                    <Option key="pdm" value="pdm">
                        pdm
                    </Option>
                    <Option key="gain" value="gain">
                        gain
                    </Option>
                </Select>
                <br />
                <br />
                <p>Type de tableau</p>
                <Radio.Group
                    value={props.blocData.tableMode || "summarized"}
                    onChange={(e) => {
                        var temp: IModule = { id: '' }
                        temp = Object.assign(temp, props.module)
                        if (temp[dataName]) {
                            props.blocData.tableMode = e.target.value as TableMapMode
                            temp[dataName].blocs[props.index] = props.blocData
                        }
                        props.updateModule(temp)
                    }}
                >
                    <Radio key={'rs'} value={'summarized'}>
                        Résumé
                    </Radio>
                    <Radio key={'dt'} value={'detailed'}>
                        Détaillé
                    </Radio>
                </Radio.Group>
                <br />
                <br />
                <p>Choix d'un potentiel</p>
                <Select
                    defaultValue={props.blocData.potentielChoice || null}
                    placeholder="potentiel"
                    onChange={(x: string) => {
                        var temp: IModule = { id: '' }
                        temp = Object.assign(temp, props.module)
                        if (temp.dataSurfacique) {
                            props.blocData.potentielChoice = x as PotentielChoice
                            temp.dataSurfacique.blocs[props.index] = props.blocData
                        }
                        moduleRef.current = temp
                    }}
                    onBlur={() => props.updateModule(moduleRef.current)}
                >
                    {listePotentiel.map((x) => (
                        <Option key={x.value} value={x.value}>
                            {x.text}
                        </Option>
                    ))}
                    <Option value={null}>Pas de potentiel</Option>
                </Select>
                <br />
                <Button
                    danger
                    icon={<DeleteOutlined />}
                    style={{ marginTop: 30 }}
                    onClick={() => {
                        var temp: IModule = { id: '' }
                        temp = Object.assign(temp, props.module)
                        if (temp.dataSurfacique) {
                            temp.dataSurfacique.blocs.splice(props.index, 1)
                        }
                        props.updateModule(temp)
                    }}
                >Supprimer le bloc</Button>
            </Form.Item>
        </div>
    )
}

export function BlocTablePontuel(props: IpropsTablePonctuel) {
    const moduleRef = useRef<IModule>(props.module)
    const { Option } = Select
    return (
        <Form.Item label="Tableau ponctuel">
            {props.module.dataPonctuel?.typeBloc !== undefined &&
                props.module?.dataPonctuel?.typeBloc !== 'noBloc' ? (
                <div>
                    <br />
                    <p>Choix des colonnes à afficher pour le bloc sélectionné</p>
                    <Select
                        mode="multiple"
                        allowClear
                        style={{ width: '100%' }}
                        placeholder="Please select"
                        defaultValue={props.blocData.colBloc}
                        onChange={(x: string[]) => {
                            var temp: IModule = { id: '' }
                            temp = Object.assign(temp, props.module)
                            if (temp.dataPonctuel) {
                                temp.dataPonctuel.blocs[props.index] = { colBloc: x, elemType: 'tablePonctuel' }
                            }
                            moduleRef.current = temp
                        }}
                        onBlur={() => props.updateModule(moduleRef.current)}
                    >
                        <Option key="k5" value="enseigne">
                            Enseigne
                        </Option>
                        <Option key="k6" value="zoneChalandise">
                            Zone de Chalandise
                        </Option>
                        <Option key="k7" value="dep">
                            N° Dép
                        </Option>
                        <Option key="k8" value="raisonSociale">
                            Raison sociale
                        </Option>
                        <Option key="k9" value="adresse">
                            Adresse
                        </Option>
                        <Option key="k10" value="codePostal">
                            Code postal
                        </Option>
                        <Option key="k11" value="commune">
                            Commune
                        </Option>
                        <Option key="k12" value="tel">
                            Tél
                        </Option>
                        <Option key="k13" value="nomPrenom">
                            Nom Prénom
                        </Option>
                        <Option key="k0" value="0">
                            colonne 1
                        </Option>
                        <Option key="k1" value="1">
                            colonne 2
                        </Option>
                        <Option key="k2" value="2">
                            colonne 3
                        </Option>
                        <Option key="k3" value="3">
                            colonne 4
                        </Option>
                        <Option key="k4" value="4">
                            colonne 5
                        </Option>
                    </Select>
                </div>
            ) : (<div></div>)
            }
        </Form.Item>
    )
}

export function BlocTableCustom(props: IpropsCustomTable) {
    const [lines, setLines] = useState<ItableCustomLine[]>(props.blocData.lines || [{ cols: ["test"], style: [undefined] }])
    const [colsWidth, setColsWidth] = useState<number[] | null>(props.blocData.colsWidthPercentage || null)

    function getNewModule(newLines, colsWidthPercentage?: number[]) {
        var temp: IModule = { id: '' }
        temp = Object.assign(temp, props.module)
        if (temp.dataMethodologie) {
            temp.dataMethodologie.blocs[props.index] = { elemType: 'tableCustom', lines: newLines, colsWidthPercentage: colsWidthPercentage }
        }
        props.updateModule(temp)
    }

    function updateNbLines(n: number) {
        const delta = n - lines.length
        if (delta > 0) {
            //add lines
            let linesToAdd: ItableCustomLine[] = []
            for (let i = 0; i < delta; i++) {
                linesToAdd.push({ cols: new Array<string>(lines[0].cols.length).fill(""), style: new Array<cellCustomStyle | undefined>(lines[0].cols.length).fill(undefined) })
            }
            setLines(lines.concat(linesToAdd))
        }
        else {
            //remove lines
            setLines(lines.slice(0, n))
        }
    }

    function updateNbColonnes(n: number) {
        const delta = n - lines[0]?.cols.length
        if (delta > 0) {
            //add cols
            setLines(lines.map(e => {
                return { cols: e.cols.concat(new Array<string>(Math.abs(delta)).fill("")), style: e.style.concat(new Array<cellCustomStyle | undefined>(Math.abs(delta)).fill(undefined)) }
            }))
        }
        else {
            //remove cols
            setLines(lines.map(e => {
                return { cols: e.cols.slice(0, n), style: e.style.slice(0, n) }
            }))
        }
    }

    function popoverContent(lineNumber: number, columnNumber: number, style?: cellCustomStyle) {
        return (
            <div>
                <p>Couleur de fond</p>
                <input type="color"
                    value={style?.backgroundColor != undefined ? style.backgroundColor : lineNumber == 0 ? "#289efa" : "#ffffff"}
                    onChange={(elem) => {
                        const newLines: ItableCustomLine[] = Array.from(lines)
                        newLines[lineNumber].style[columnNumber] = { ...lines[lineNumber].style[columnNumber], backgroundColor: elem.currentTarget.value }
                        getNewModule(newLines)
                        setLines(newLines)
                    }}
                />
                <br />
                <br />
                <p>Taille de la police</p>
                <InputNumber defaultValue={style?.fontSize != undefined ? style.fontSize : 15}
                    onBlur={(elem) => {
                        const newLines: ItableCustomLine[] = Array.from(lines)
                        newLines[lineNumber].style[columnNumber] = { ...lines[lineNumber].style[columnNumber], fontSize: Number.parseInt(elem.currentTarget.value) || undefined }
                        getNewModule(newLines)
                        setLines(newLines)
                    }}
                />
                <br />
                <br />
                <p>Couleur de la police</p>
                <input type="color"
                    value={style?.color != undefined ? style.color : lineNumber == 0 ? "#ffffff" : "#000000"}
                    onChange={(elem) => {
                        const newLines: ItableCustomLine[] = Array.from(lines)
                        newLines[lineNumber].style[columnNumber] = { ...lines[lineNumber].style[columnNumber], color: elem.currentTarget.value }
                        getNewModule(newLines)
                        setLines(newLines)
                    }}
                />
                <br />
                <br />
                <p>Texte en gras?</p>
                <Switch defaultChecked={style?.strong != undefined ? style.strong : lineNumber == 0 ? true : false}
                    onChange={(elem) => {
                        const newLines: ItableCustomLine[] = Array.from(lines)
                        newLines[lineNumber].style[columnNumber] = { ...lines[lineNumber].style[columnNumber], strong: elem }
                        getNewModule(newLines)
                        setLines(newLines)
                    }}
                />
            </div>
        )
    }

    return (
        <Form.Item label="Tableau custom">
            {colsWidth && (
                <div>
                    <p>Largeur des lignes :</p>
                    <table>
                        <tbody>
                            <tr>
                                {lines[0].cols.map((e, index) => (
                                    <td key={"tableCustomColWidth" + props.indexModule + props.index + index}>
                                        <Input type="number" addonAfter="%" defaultValue={colsWidth[index]} onBlur={(e) => {
                                            colsWidth[index] = Number.parseInt(e.target.value)
                                            setColsWidth(colsWidth)
                                            getNewModule(lines, colsWidth)
                                        }} />
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                    <br />
                    <Button onClick={() => {
                        setColsWidth(null)
                        getNewModule(lines)
                    }} icon={<DeleteOutlined />} style={{ marginBottom: '20px' }}>Annuler la modification de la largeur des colonnes</Button>
                </div>
            )}
            {!colsWidth && (
                <Button style={{ marginBottom: '20px' }} onClick={() => setColsWidth(new Array(lines[0].cols.length).fill(0))} icon={<EditOutlined />}>Modifier la largeur des colonnes</Button>
            )}
            <p>Nb de lignes :</p>
            <Slider defaultValue={lines.length} max={15} min={1} onChange={(e) => updateNbLines(e)} />
            <p defaultValue={lines.length}>Nb de colonnes :</p>
            <Slider defaultValue={lines[0].cols.length} max={5} min={1} onChange={(e) => updateNbColonnes(e)} />
            <table>
                <tbody>
                    {lines.map((e, indexTr) => (
                        <tr key={"tableCustomRow" + indexTr}>
                            {lines.length > 0 && lines[indexTr].cols.map((e, indexTd) => (
                                <td key={"tableCustomCol" + indexTr + indexTd}>
                                    <div style={{ display: 'flex', marginBottom: '5px' }}>
                                        <Input defaultValue={e} onBlur={(event) => {
                                            let temp: ItableCustomLine[] = Array.from(lines)
                                            temp[indexTr].cols[indexTd] = event.currentTarget.value
                                            getNewModule(temp)
                                            setLines(temp)
                                        }} />
                                        <div style={{ margin: '0 20px 0 5px' }} >
                                            <Popover placement="right" title={<span>Style de la cellule</span>} content={() => popoverContent(indexTr, indexTd, lines[indexTr].style[indexTd])} trigger="click">
                                                <Button type="primary" shape="circle" icon={<FormatPainterOutlined />} />
                                            </Popover>
                                        </div>
                                    </div>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            <Button
                danger
                icon={<DeleteOutlined />}
                style={{ marginTop: 30 }}
                onClick={() => {
                    var temp: IModule = { id: '' }
                    temp = Object.assign(temp, props.module)
                    if (temp.dataMethodologie) {
                        temp.dataMethodologie.blocs.splice(props.index, 1)
                    }
                    props.updateModule(temp)
                }}
            >Supprimer le bloc</Button>
        </Form.Item>
    )
}
